import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
// LoginSwitch picks v2 or v1 from the redesign feature flag.
// Once v2 is the default, swap this back to './../../Login/Login' and delete LoginSwitch.
import Login from './../../Login/LoginSwitch';
import './LoginPage.css';
import SessionHelper from '../../Helper/SessionHelper';
import RouteConfig from '../../../constants/RouteConfig';

function LoginPage() {
  const location = useLocation();

  // If user is logged in, redirect to the first available route they have permission for
  if (SessionHelper.isLoggedIn()) {
    const navRoutes = RouteConfig
      .filter(route => route.label && SessionHelper.hasPermission(route.requiredPermissions))
      .sort((a, b) => a.order - b.order);

    // If there are no routes with permissions, redirect to a default route
    const route = navRoutes.length > 0 ? navRoutes[0] : { path: "/my-account" };

    return (
      <Navigate
        to={route.path}
        state={{ from: location }}
        replace
      />
    );
  }

  return (
    <div className="LoginPage">
      <Login />
    </div>
  );
}

export default LoginPage;
